export const getMyCart = (localStorageKey, defaultValue) => JSON.parse(localStorage.getItem(localStorageKey) ?? defaultValue);